import React from 'react';
import Geniusify from './pages/Geniusify'
import './App.css';

function App() {
  return (
    <div className="App">
      <Geniusify/>
    </div>
  );
}

export default App;
